/* eslint-disable global-require */
const navigations = [
  {
    name: '首页',
    path: '/'
  },
  {
    name: '研究院概况',
    path: '/about/profile',
    order: '01',
    background: require('@/assets/images/about_mapbg.png'),
    children: [
      {
        name: '研究院简介',
        path: '/about/profile'
      },
      {
        name: '研究院领导',
        path: '/about/leaders'
      },
      // {
      //   name: '历任领导',
      //   path: '/about/previous'
      // },
      {
        name: '行政办公',
        path: '/about/office'
      },
    ]
  },
  // {
  //   name: '师资队伍',
  //   path: '/faculty/teachers',
  //   order: '02',
  //   background: require('@/assets/images/faculty_bg.png'),
  //   children: [
  //     {
  //       name: '教师名录',
  //       path: '/faculty/teachers'
  //     },
  //     {
  //       name: '杰出人才',
  //       path: '/faculty/talent'
  //     },
  //     {
  //       name: '博士后',
  //       path: '/faculty/postdoctoral'
  //     }
  //   ],
  // },
  {
    name: '新闻通告',
    path: '/info/news',
    order: '02',
    background: require('@/assets/images/dynamic_bg.png'),
    children: [
      {
        name: '新闻信息',
        path: '/info/news'
      },
      {
        name: '学术动态',
        path: '/info/academic'
      },
      {
        name: '通知公告',
        path: '/info/announcements'
      },
      {
        name: '招聘信息',
        path: '/info/jobs'
      },
    ],
  },
  {
    name: '人才培养',
    path: '/cultivate/postgraduate',
    order: '03',
    children: [
      {
        name: '吴文俊人工智能荣誉博士班',
        path: '/cultivate/postgraduate'
      },
    ]
  },
  {
    name: '科学研究',
    path: '/research/directions',
    order: '04',
    background: require('@/assets/images/research_bg.png'),
    children: [
      {
        name: '学科基地',
        path: '/research/bases'
      },
      {
        name: '科研成果',
        path: '/research/results'
      },
    ],
  },
]

export default navigations



// WEBPACK FOOTER //
// ./src/utils/lang/navigations.cn.js